import { useState, useEffect } from 'react'
import Card from '../components/Card'

const timezones = [
  { value: 'America/New_York', label: 'Eastern Time (ET)' },
  { value: 'America/Chicago', label: 'Central Time (CT)' },
  { value: 'America/Denver', label: 'Mountain Time (MT)' },
  { value: 'America/Los_Angeles', label: 'Pacific Time (PT)' },
  { value: 'Europe/London', label: 'London (GMT)' },
  { value: 'Europe/Paris', label: 'Paris (CET)' },
  { value: 'Asia/Tokyo', label: 'Tokyo (JST)' },
  { value: 'Asia/Shanghai', label: 'Shanghai (CST)' },
]

export default function TimezoneConverter() {
  const [fromTimezone, setFromTimezone] = useState('America/New_York')
  const [toTimezone, setToTimezone] = useState('Europe/London')
  const [fromDateTime, setFromDateTime] = useState(new Date().toISOString().slice(0, 16))
  const [convertedTime, setConvertedTime] = useState('')

  useEffect(() => {
    convertTime()
  }, [fromTimezone, toTimezone, fromDateTime])

  const convertTime = () => {
    if (!fromDateTime) return

    try {
      const date = new Date(fromDateTime)
      const fromTime = new Date(
        date.toLocaleString('en-US', { timeZone: fromTimezone })
      )
      const toTime = new Date(
        date.toLocaleString('en-US', { timeZone: toTimezone })
      )

      const offset = toTime.getTime() - fromTime.getTime()
      const converted = new Date(date.getTime() + offset)
      setConvertedTime(converted.toISOString().slice(0, 16))
    } catch (error) {
      console.error('Error converting time:', error)
    }
  }

  return (
    <div className="space-y-6">
      <Card>
        <Card.Body>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
            <div>
              <label className="label">From Time Zone:</label>
              <select
                value={fromTimezone}
                onChange={(e) => setFromTimezone(e.target.value)}
                className="input w-full"
              >
                {timezones.map((tz) => (
                  <option key={tz.value} value={tz.value}>
                    {tz.label}
                  </option>
                ))}
              </select>
            </div>
            <div>
              <label className="label">To Time Zone:</label>
              <select
                value={toTimezone}
                onChange={(e) => setToTimezone(e.target.value)}
                className="input w-full"
              >
                {timezones.map((tz) => (
                  <option key={tz.value} value={tz.value}>
                    {tz.label}
                  </option>
                ))}
              </select>
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div>
              <label className="label">Date & Time:</label>
              <input
                type="datetime-local"
                value={fromDateTime}
                onChange={(e) => setFromDateTime(e.target.value)}
                className="input w-full"
              />
            </div>
            <div>
              <label className="label">Converted Time:</label>
              <input
                type="datetime-local"
                value={convertedTime}
                readOnly
                className="input w-full bg-gray-50"
              />
            </div>
          </div>
        </Card.Body>
      </Card>
    </div>
  )
}

